package com.tfc.care.tfccare.ui.components

import androidx.compose.foundation.Image
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp

val Icons.TfcPayLogoDark: ImageVector
    get() {
        if (_tfcPayLogoDark != null) {
            return _tfcPayLogoDark!!
        }
        _tfcPayLogoDark =
            Builder(
                    name = "TfcPayLogoDark",
                    defaultWidth = 990.0.dp,
                    defaultHeight = 190.0.dp,
                    viewportWidth = 990.12f,
                    viewportHeight = 190.03f,
                )
                .apply {
                    path(
                        fill = SolidColor(Color(0xFF22C55E)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(0.0f, 2.25f)
                        verticalLineToRelative(42.0f)
                        horizontalLineTo(51.71f)
                        verticalLineTo(187.0f)
                        horizontalLineTo(101.9f)
                        verticalLineTo(44.23f)
                        horizontalLineToRelative(51.71f)
                        verticalLineToRelative(-42.0f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF22C55E)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(214.72f, 46.15f)
                        curveToRelative(1.0f, -1.13f, 3.05f, -1.66f, 6.23f, -1.66f)
                        horizontalLineToRelative(78.66f)
                        verticalLineToRelative(-42.0f)
                        horizontalLineTo(193.47f)
                        curveToRelative(-11.46f, 0.0f, -19.33f, 2.64f, -23.77f, 8.0f)
                        reflectiveCurveTo(163.14f, 24.0f, 163.14f, 35.0f)
                        verticalLineTo(187.24f)
                        horizontalLineToRelative(50.13f)
                        verticalLineTo(122.62f)
                        horizontalLineToRelative(75.0f)
                        verticalLineToRelative(-42.0f)
                        horizontalLineToRelative(-75.0f)
                        verticalLineTo(52.37f)
                        curveTo(213.27f, 49.39f, 213.8f, 47.34f, 214.72f, 46.15f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF22C55E)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(431.3f, 116.0f)
                        arcToRelative(55.0f, 55.0f, 0.0f, false, true, -4.7f, 15.83f)
                        arcToRelative(27.64f, 27.64f, 0.0f, false, true, -7.55f, 9.4f)
                        arcToRelative(25.12f, 25.12f, 0.0f, false, true, -9.4f, 4.5f)
                        arcToRelative(43.62f, 43.62f, 0.0f, false, true, -10.26f, 1.13f)
                        horizontalLineToRelative(-8.48f)
                        arcToRelative(38.64f, 38.64f, 0.0f, false, true, -12.25f, -1.92f)
                        arcToRelative(22.81f, 22.81f, 0.0f, false, true, -10.53f, -7.82f)
                        curveToRelative(-3.11f, -3.84f, -5.62f, -9.2f, -7.54f, -16.0f)
                        reflectiveCurveToRelative(-2.92f, -15.56f, -2.92f, -26.29f)
                        curveToRelative(0.0f, -10.92f, 1.0f, -19.73f, 2.92f, -26.42f)
                        reflectiveCurveToRelative(4.43f, -11.92f, 7.54f, -15.82f)
                        arcToRelative(22.17f, 22.17f, 0.0f, false, true, 10.53f, -7.75f)
                        arcToRelative(38.71f, 38.71f, 0.0f, false, true, 12.25f, -2.0f)
                        horizontalLineToRelative(8.48f)
                        arcToRelative(43.64f, 43.64f, 0.0f, false, true, 10.26f, 1.2f)
                        arcToRelative(25.0f, 25.0f, 0.0f, false, true, 9.4f, 4.43f)
                        arcToRelative(28.24f, 28.24f, 0.0f, false, true, 7.55f, 9.4f)
                        arcToRelative(33.43f, 33.43f, 0.0f, false, true, 2.12f, 5.3f)
                        horizontalLineToRelative(49.06f)
                        arcToRelative(127.23f, 127.23f, 0.0f, false, false, -4.0f, -17.81f)
                        arcToRelative(57.52f, 57.52f, 0.0f, false, false, -13.05f, -23.24f)
                        curveToRelative(-6.09f, -6.62f, -14.23f, -11.79f, -24.56f, -15.63f)
                        reflectiveCurveTo(412.83f, 0.93f, 397.0f, 0.93f)
                        horizontalLineToRelative(-3.71f)
                        curveToRelative(-17.94f, 0.0f, -32.5f, 2.45f, -43.83f, 7.35f)
                        reflectiveCurveToRelative(-19.93f, 11.65f, -26.08f, 20.06f)
                        arcTo(74.29f, 74.29f, 0.0f, false, false, 310.8f, 58.2f)
                        arcToRelative(195.0f, 195.0f, 0.0f, false, false, -3.25f, 36.68f)
                        arcToRelative(195.0f, 195.0f, 0.0f, false, false, 3.25f, 36.68f)
                        arcToRelative(74.29f, 74.29f, 0.0f, false, false, 12.58f, 29.86f)
                        quadToRelative(9.22f, 12.62f, 26.08f, 20.07f)
                        curveToRelative(11.33f, 4.89f, 25.89f, 7.34f, 43.83f, 7.34f)
                        horizontalLineTo(397.0f)
                        curveToRelative(15.83f, 0.0f, 28.94f, -1.92f, 39.2f, -5.76f)
                        reflectiveCurveToRelative(18.47f, -9.13f, 24.56f, -15.75f)
                        arcToRelative(57.66f, 57.66f, 0.0f, false, false, 13.05f, -23.0f)
                        arcTo(138.64f, 138.64f, 0.0f, false, false, 479.1f, 116.0f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFFFFFFFF)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(649.33f, 47.47f)
                        arcToRelative(68.42f, 68.42f, 0.0f, false, false, -8.8f, -21.85f)
                        arcTo(53.9f, 53.9f, 0.0f, false, false, 624.0f, 9.07f)
                        curveToRelative(-6.88f, -4.37f, -15.49f, -6.55f, -25.89f, -6.55f)
                        horizontalLineTo(495.46f)
                        verticalLineTo(62.0f)
                        horizontalLineToRelative(84.22f)
                        curveToRelative(6.36f, 0.0f, 11.26f, 2.05f, 14.76f, 6.16f)
                        reflectiveCurveToRelative(5.3f, 10.79f, 5.3f, 19.92f)
                        reflectiveCurveToRelative(-1.85f, 15.56f, -5.56f, 19.14f)
                        reflectiveCurveToRelative(-8.54f, 5.43f, -14.5f, 5.43f)
                        horizontalLineTo(510.12f)
                        arcToRelative(14.66f, 14.66f, 0.0f, false, false, -14.66f, 14.66f)
                        verticalLineToRelative(60.0f)
                        horizontalLineTo(545.0f)
                        verticalLineTo(165.3f)
                        arcToRelative(14.67f, 14.67f, 0.0f, false, true, 14.67f, -14.67f)
                        lineToRelative(38.27f, -0.46f)
                        curveToRelative(10.39f, 0.0f, 19.0f, -2.19f, 25.89f, -6.49f)
                        reflectiveCurveToRelative(15.48f, -14.3f, 19.58f, -24.83f)
                        curveToRelative(2.85f, -7.33f, 5.0f, -16.16f, 6.7f, -24.0f)
                        reflectiveCurveTo(652.0f, 77.53f, 652.0f, 70.32f)
                        arcTo(104.83f, 104.83f, 0.0f, false, false, 649.33f, 47.47f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFFFFFFFF)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(759.44f, 2.52f)
                        curveToRelative(-10.72f, 0.0f, -19.66f, 0.66f, -26.81f, 2.11f)
                        arcToRelative(45.87f, 45.87f, 0.0f, false, false, -18.34f, 7.62f)
                        arcToRelative(52.33f, 52.33f, 0.0f, false, false, -13.58f, 15.29f)
                        arcToRelative(190.18f, 190.18f, 0.0f, false, false, -12.31f, 25.1f)
                        lineToRelative(-55.68f, 134.6f)
                        horizontalLineToRelative(53.36f)
                        lineToRelative(12.38f, -30.58f)
                        horizontalLineToRelative(61.0f)
                        verticalLineToRelative(30.58f)
                        lineTo(809.0f, 187.24f)
                        lineTo(809.0f, 2.52f)
                        close()
                        moveTo(759.44f, 114.68f)
                        lineTo(715.61f, 114.68f)
                        lineToRelative(14.0f, -34.3f)
                        curveToRelative(4.77f, -11.65f, 9.47f, -20.26f, 14.17f, -25.89f)
                        reflectiveCurveToRelative(9.87f, -8.87f, 15.69f, -9.73f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFFFFFFFF)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(936.56f, 2.52f)
                        lineTo(902.79f, 68.73f)
                        lineTo(867.9f, 2.52f)
                        horizontalLineTo(816.19f)
                        lineTo(879.0f, 122.36f)
                        verticalLineToRelative(64.88f)
                        horizontalLineToRelative(49.86f)
                        verticalLineTo(119.18f)
                        lineTo(990.12f, 2.52f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF22C55E)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(401.36f, 110.77f)
                        horizontalLineTo(385.29f)
                        arcToRelative(7.85f, 7.85f, 0.0f, false, true, -7.85f, -7.86f)
                        verticalLineTo(86.85f)
                        arcTo(7.85f, 7.85f, 0.0f, false, true, 385.29f, 79.0f)
                        horizontalLineToRelative(16.07f)
                        arcToRelative(7.86f, 7.86f, 0.0f, false, true, 7.86f, 7.86f)
                        verticalLineToRelative(16.06f)
                        arcTo(7.86f, 7.86f, 0.0f, false, true, 401.36f, 110.77f)
                        close()
                    }
                }
                .build()
        return _tfcPayLogoDark!!
    }

private var _tfcPayLogoDark: ImageVector? = null


@Preview
@Composable
private fun TfcPayLogoDarkPreview() {
    Image(
        imageVector = Icons.TfcPayLogoDark,
        contentDescription = null,
    )
}